import { ConversionEvents } from '../components/ConversionEvents/ConversionEvents';
import { ConversionTypeContent } from '../components/ConversionTypeContent/ConversionTypeContent';
import { ConversionTypeSetup } from '../components/ConversionTypeSetup/ConversionTypeSetup';
import { NoEvents } from '../components/NoEvents/NoEvents';
import { SetupClicksEventCategory } from '../components/SetupClicksEventCategory/SetupClicksEventCategory';
import { SetupValue } from '../components/SetupValue/SetupValue';
import { CODELESS_CONVERSION_TYPE_OPTIONS } from './codelessConversionTypeOptions';
import { CONVERSIONS_TABS } from './conversionTabs';

export const conversionTabItems = [
    {
        id: CONVERSIONS_TABS.EVENTS_ON_THIS_PAGE,
        caption: {
            id: 'codeless.events.on.this.page.tab',
            defaultMessage: 'Events On this page',
        },
        renderSteps: ({ currentConversion, existingConversions = [] }) => [
            {
                content:
                    existingConversions.length > 0 ? (
                        <ConversionEvents conversions={existingConversions} />
                    ) : (
                        <NoEvents />
                    ),
                id: 'step-one',
                showTabNavigation: true,
            },
            {
                content: <ConversionTypeSetup />,
                id: 'step-two',
            },
            {
                content: <ConversionTypeContent styleFrame />,
                id: 'step-three',
            },
            ...(currentConversion && currentConversion.conversionType === CODELESS_CONVERSION_TYPE_OPTIONS.BUTTON_CLICKS
                ? [
                      {
                          content: <SetupClicksEventCategory />,
                          id: 'step-five',
                      },
                      {
                          content: <SetupValue />,
                          id: 'step-six',
                      },
                  ]
                : []),
        ],
    },
    {
        id: CONVERSIONS_TABS.ALL_YOUR_EVENTS,
        caption: {
            id: 'codeless.all.your.events.tab',
            defaultMessage: 'All Your events',
        },
        renderSteps: ({ conversions = [], currentConversion }) => [
            {
                content: conversions.length > 0 ? <ConversionEvents conversions={conversions} /> : <NoEvents />,
                id: 'step-one',
                showTabNavigation: true,
            },
            {
                content: <ConversionTypeSetup />,
                id: 'step-two',
            },
            {
                content: <ConversionTypeContent styleFrame />,
                id: 'step-three',
            },
            ...(currentConversion && currentConversion.conversionType === CODELESS_CONVERSION_TYPE_OPTIONS.BUTTON_CLICKS
                ? [
                      {
                          content: <SetupClicksEventCategory />,
                          id: 'step-five',
                      },
                  ]
                : []),
        ],
    },
];
